import angular from 'angular';
import searchComponent from './product-search.component';

export default angular.module('components.app.products.productSearch', [])
  .component('productSearch', searchComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/products/product-search/product-search.module.js